module.exports = __webpack_public_path__ + "img/swedish.d46dbac2.svg";